import React from 'react';
import Grid from "@mui/material/Grid";
import MenuIcon from '@mui/icons-material/Menu';
import Fab from '@mui/material/Fab';
import AddToDriveSharpIcon from '@mui/icons-material/AddToDriveSharp';
import {FaFolderOpen} from 'react-icons/fa'
import AddchartSharpIcon from '@mui/icons-material/AddchartSharp';
import DirectionsSharpIcon from '@mui/icons-material/DirectionsSharp';
import ManageSearchSharpIcon from '@mui/icons-material/ManageSearchSharp';
import { useDispatch } from 'react-redux';
import { bgColors } from "../utils/bgColor";
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import {openSurveySearchDialog, openUserFolio} from "../../redux/actions/controlbuttonaction"
const IconButtonStyle = {
  marginTop:'0.25rem',
  color: bgColors.grey_800,
  backgroundColor: bgColors.grey_300
}
const iconStyle = {
  color: bgColors.grey_800,
  height:'20px',
  width:'20px'
}

const ControlButtons = (props) => {
  const {openMenu, openAnalysisWindow,
    openUserProjectWindow,
    openNavigationWindow} = props
  const dispatch = useDispatch()
  return (
<>
<div style={{
                position:'absolute',
                left:0,
                display: 'inline-block',
                direction:'column',
                padding:2,
                justifyContent:'space-between',
                // display: 'grid',
                // direction:'row'
                }}>
      <Fab 
        aria-label="add"
        size='small'
        
        onClick={() => dispatch(openMenu)}
        sx={{marginLeft:'0.5rem'}} 
      >
          <MenuIcon  
           style={iconStyle}
           />
        </Fab>
        <Fab variant="extended" key = {'open_survey_search_button'} size='small' 
        sx={{marginLeft:'0.5rem'}} 
        onClick={()=> dispatch(openSurveySearchDialog)} 
        >
          
        <ManageSearchSharpIcon sx={{ mr: 1}} />
            Survey
        </Fab>
      </div>
        <div style={{
                position:'absolute',
                right:0,
                display: 'inline-block',
                direction:'column',
                padding:2,
                justifyContent:'space-between',
                // display: 'grid',
                // direction:'row'
                }}>
        {/* <Grid item > */}
        <Fab   
          aria-label="add"
          size='small'
          sx = {{ marginLeft:'0.75rem'}}
          // onClick = {AnaylysisWindowOpen}
          onClick={() => dispatch(openAnalysisWindow)}
          // style = {IconButtonStyle}
        >
        <AddchartSharpIcon  style={iconStyle}/>

      </Fab>
      <Fab  
        aria-label="add"
        size='small'
        onClick={() => dispatch(openUserProjectWindow)}
        sx = {{ marginLeft:'0.5rem'}}
        // style = {IconButtonStyle}
      >
      <CloudUploadIcon  style={iconStyle}/>
      </Fab>
      <Fab  
            aria-label="user folio "
            size='small'
            onClick={() => dispatch(openUserFolio)}
            sx = {{ marginLeft:'0.5rem'}}
          >
          < FaFolderOpen style={iconStyle}/>
      </Fab>
      <Fab  
        aria-label="add"
        size='small'
        onClick={() => dispatch(openNavigationWindow)}
        sx = {{ marginLeft:'0.5rem'}}
        >
      <DirectionsSharpIcon style={iconStyle}/>
      </Fab> 
    </div>
</>
  );
};

export default ControlButtons